<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Total Staked" more="/supply" :help="help1" :secondline="$options.filters.toInt(totalStakedPercentage, 2, '%')" color="#07D3DA">{{ totalStaked | toInt(0, "WISE")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Active Stakes" more="/price" :help="help2" color="#C6362F">{{ activeStakes | toInt(0, "")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Average Stake" more="/price"  :help="help3" :secondline="$options.filters.toInt(avgStakeSize, 0, 'WISE')" color="#BDD358">{{ avgStakeLength | toInt(0, "Days")}}</NumberCard>
      </v-col>
      <v-col cols="12" md="6" lg="3">
        <NumberCard title="Stakes Ending the next 7 days" :help="help4" :secondline="$options.filters.toCurrency(stakesEndingUSD, 0, 'USD')" more="/staking" color="#E28413">{{ stakesEnding | toInt(0, "WISE")}}</NumberCard>
      </v-col>
    </v-row>

    <v-row class="">
      <v-col cols="12" md="4" lg="4">
        <StakeStatsNew />
      </v-col>
      <v-col cols="12" md="8" lg="8">
        <Stakes />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <LadderStaker />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import StakeStatsNew from "@/components/StakeStatsNew.vue";
  // import StakeStats from "@/components/StakeStats.vue";
  import Stakes from "@/components/Stakes.vue";
  import LadderStaker from "@/components/LadderStaker.vue";
  import NumberCard from "@/components/widgets/NumberCard.vue";

  import {
    mapState
  } from 'vuex';

  import axios from "axios";

  import {
    apiUrl
  } from "../utils/dataPoller";

  export default {
    name: "Staking",
    components: {
      // StakeStats,
      StakeStatsNew,
      Stakes,
      LadderStaker,
      NumberCard
    },
    data() {
      return {
        help1: "",
        help2: "",
        help3: "Weighted Average Stake Length",
        help4: "Amount of WISE that will become liquid during the next 7 days",
        totalStaked: 0,
        totalStakedPercentage: 0,
        activeStakes: 0,
        avgStakeLength: 0,
        avgStakeSize: 0,
        stakesEnding: 0,
        stakesEndingUSD: 0,
        currentPriceUSD: 0,
      }
    },
    computed: {
      ...mapState({
        totalStakedState: state => state.totalStaked,
        stakeStats: state => state.stakeStats,
        currentETHPrice: state => state.currentETHPrice,
        uniswapPrice: state => state.currentUniswapStats.priceETH
      }),
    },
    mounted() {
      this.updateAllCards();
      this.updateCurrentPriceUSD();
    },
    methods: {
      updateCurrentPriceUSD() {
        this.currentPriceUSD = this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
      },
      updateAllCards() {
        this.updateCard1();
        this.updateCard2();
        this.updateCard3();
        this.updateCard4();
      },
      isDataFetchedCard1() {
        return (
          this.$store.state.totalStaked > -1
        )
      },
      isDataFetchedCard2() {
        return (
          this.$store.state.stakeStats.numberActiveStakes > -1
        )
      },
      isDataFetchedCard3() {
        return (
          this.$store.state.stakeStats.weightedAverageStakeLength > -1 &&
          this.$store.state.stakeStats.averageStakeSize > -1
        )
      },
      isDataFetchedCard4() {
        return (
          this.$store.state.currentWiseDay > -1
        )
      },
      updateCard1() {
        if (this.isDataFetchedCard1()) {
          let totalStaked = this.$store.state.totalStaked;
          let totalLiquid = this.$store.state.totalSupply - this.$store.state.uniswapBalance;
          this.totalStaked = totalStaked;
          this.totalStakedPercentage = totalStaked / (totalStaked + totalLiquid) * 100;
        }
      },
      updateCard2() {
        if (this.isDataFetchedCard2()) {
          this.activeStakes = this.$store.state.stakeStats.numberActiveStakes;
        }
      },
      updateCard3() {
        if (this.isDataFetchedCard3()) {
          this.avgStakeLength = this.$store.state.stakeStats.weightedAverageStakeLength;
          this.avgStakeSize = this.$store.state.stakeStats.averageStakeSize;
        }
      },
      async updateCard4() {
        if (this.isDataFetchedCard4()) {

          this.stakesEnding = await this.getEndingStakeWise();

          this.stakesEndingUSD = this.stakesEnding * this.currentPriceUSD;

        }
      },
      async getEndingStakeWise() {

          if (this.$store.state.currentWiseDay < 51) return;

          // let url_stakestarts = "https://wiseinfo.io/api_alpha/stakestarts_byenddayrange"
          // let url_stakends = "https://wiseinfo.io/api_alpha/stakeends_stakeids"
          let url_stakestarts = apiUrl + "/stakestarts_byenddayrange"
          let url_stakends = apiUrl + "/stakeends_stakeids"

          let parameters = {
            params: {
              endDayFrom: this.$store.state.currentWiseDay,
              endDayTo: this.$store.state.currentWiseDay + 7 - 1,
            }
          };
          let stakesMap = new Map();
          let stakeStarts = await axios.get(url_stakestarts, parameters);
          let stakeEnds = await axios.get(url_stakends, parameters);
          let stakeEndsArray = stakeEnds.data.map(stakeEnd => stakeEnd.stakeId);

          // initialize map with all days and 0
          for (let i = parameters.params.endDayFrom; i <= parameters.params.endDayTo; i++) {
            stakesMap.set(i, 0);
          }

          for (let stakeStart of stakeStarts.data) {
            let stakeId = stakeStart.stakeId;
            if (!stakeEndsArray.includes(stakeId)) {
              let endDay = stakeStart.endDay;
              let stakedAmount = stakeStart.stakedAmount;
              let currentDayValue = stakesMap.get(endDay);
              // stakesMap.set("Day " + endDay, currentDayValue + stakedAmount);
              stakesMap.set(endDay, currentDayValue + stakedAmount);
            }
          }

          let cumulativeSum = Array.from(stakesMap.values()).reduce(((sum,value) => sum += value),0);

          return cumulativeSum;


      },
    },
    watch: {
      totalStakedState() {
        this.updateCard1();
      },
      stakeStats() {
        this.updateCard2();
        this.updateCard3();
      },
      urrentETHPrice() {
        this.updateCurrentPriceUSD();
      },
      uniswapPrice() {
        this.updateCurrentPriceUSD();
      }
    }
  }
</script>

<style lang="css" scoped>
</style>
